/** id from GET /api/profile/ */
export function resolveProfileUserId(user) {
  if (user == null) return null
  const id = user.id ?? user.pk
  if (id == null || id === '') return null
  return id
}
